<template>
  <div id="nav-despre">
    <div class="text-center">
      <h2 class="title line center">Despre noi</h2>
      <p class="heading center special">
        Brașov Trail Adventures
      </p>
      <div class="padding-onlytop-md">
        <p>
          BTA Hammocks sunt fabricate cu pasiune în atelierul propriu din
          Brașov. <br />
          Hamacele sunt ușoare și compacte, se potrivesc pentru orice ieșire în
          natură și asigură tot confortul în aer liber.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
.text {
  padding: 50px 0;
  text-align: center;
}

h2 {
  margin-top: 45px;
  color: #2f2911;
  text-transform: uppercase;
  position: relative;
  letter-spacing: 0;
  font-size: 26px;
  line-height: 40px;
  font-weight: 300;
}

.padding-onlytop-md {
  padding-top: 30px !important;
}

.special {
  text-align: center;
  color: #6e6b66;
  font-size: 18px;
  line-height: 20px;
  margin: 0 auto;
}

h2.title.line {
  margin-top: 45px;
}

h2.title.line:after {
  position: absolute;
  content: "";
  display: block;
  margin: 0 auto;
  left: 0;
  right: 0;
  z-index: -1;
  height: 40px;
  width: 2px;
  background-color: #0072bb;
  top: -50px;
}
</style>
